export const designerOptions = [
  { value: "", label: "" },
  {
    value: "ira",
    label: (
      
        <img
          src={`${process.env.PUBLIC_URL}/assets/ira.png`}
          style={{ height: "55px" }}
          alt="ira"
        />
      
    ),
  },
  {
    value: "nati",
    label: (
     
        <img
          src={`${process.env.PUBLIC_URL}/assets/nati.png`}
          style={{ height: "55px" }}
          alt="nati"
          title="Nati"
        />
      
    ),
  },
  {
    value: "shahar",
    label: (
      
        <img
          src={`${process.env.PUBLIC_URL}/assets/shahar.png`}
          style={{ height: "55px" }}
          alt="shahar"
        />
      
    ),
  },
  {
    value: "gay",
    label: (
        <img
          src={`${process.env.PUBLIC_URL}/assets/gay.png`}
          style={{ height: "45px"}}
          alt="gay"
        />
     
    ),
  },
];

export const managerOptions = [
  { value: "", label: "" },
  {
    value: "נינה",
    label: (
      
        <img
          src={`${process.env.PUBLIC_URL}/assets/נינה.png`}
          style={{ height: "45px" }}
          alt="נינה"
          title="נינה"
        />
      
    ),
  },
  {
    value: "Avi Duanis",
    label: (
      
        <img
          src={`${process.env.PUBLIC_URL}/assets/Avi Duanis.png`}
          style={{ height: "45px" }}
          alt="Avi Duanis"
          title="Avi Duanis"
        />
      
    ),
  },
  {
    value: "Flori",
    label: (
      
        <img
          src={`${process.env.PUBLIC_URL}/assets/Flori.png`}
          style={{ height: "45px" }}
          alt="Flori"
          title="Flori"
        />
      
    ),
  },
  {
    value: "Michael Smadja",
    label: (
     
        <img
          src={`${process.env.PUBLIC_URL}/assets/Michael Smadja.png`}
          style={{ height: "45px" }}
          alt="Michael Smadja"
          title="Michael Smadja"
        />
      
    ),
  },
  {
    value: "Roy Duanis",
    label: (
      
        <img
          src={`${process.env.PUBLIC_URL}/assets/Roy Duanis.png`}
          style={{ height: "45px" }}
          alt="Roy Duanis"
          title="Roy Duanis"
        />
      
    ),
  },
  {
    value: "shahar",
    label: (
      
        <img
          src={`${process.env.PUBLIC_URL}/assets/shahar.png`}
          style={{ height: "45px" }}
          alt="shahar"
        />
      
    ),
  },
  {
    value: "Zvika",
    label: (
      
        <img
          src={`${process.env.PUBLIC_URL}/assets/Zvika.png`}
          style={{ height: "45px" }}
          alt="Zvika"
          title="Zvika"
        />
      
    ),
  },
  {
    value: "אבי אולמן",
    label: (
      
        <img
          src={`${process.env.PUBLIC_URL}/assets/אבי אולמן.png`}
          style={{ height: "45px" }}
          alt="Zvika"
          title="Zvika"
        />
      
    ),
  },
];

export const inWorkOptions = [
  { value: "", label: "" },
  {
    value: "inWork",
    label: (
      <div style={{ display: "flex", alignItems: "center" }}>
        <img
          src={`${process.env.PUBLIC_URL}/assets/inWork.png`}
          style={{ height: "45px" }}
          alt="inWork"
        />
      </div>
    ),
  },
  {
    value: "gayStatus",
    label: (
      <div style={{ display: "flex", alignItems: "center" }}>
        <img
          src={`${process.env.PUBLIC_URL}/assets/gayStatus.png`}
          style={{ height: "45px" }}
          alt="gayStatus"
        />
      </div>
    ),
  },
];
export const statusOptions =[
  { value: "", label: "" },
  {
    value: "ready",
    label: (
      <div className="h-[100%]  content-center">
      <img
        src={`${process.env.PUBLIC_URL}/assets/ready.png`||''}
        style={{ height: "90%",width: "90%", margin: "auto" }}
        alt="ready"
        title="ready"
      />
    </div>
    ),
  },
   {
    value: "rip",
    label: (
      <div className="h-[100%]  content-center">
      <img
        src={`${process.env.PUBLIC_URL}/assets/rip.png`||''}
        style={{ height: "90%",width: "90%", margin: "auto" }}
        alt="rip"
        title="rip"
      />
    </div>
    ),
  },
  {
    value: "print",
    label: (
      <div className="h-[100%]  content-center">
      <img
        src={`${process.env.PUBLIC_URL}/assets/print.png`||''}
        style={{ height: "90%",width: "90%", margin: "auto" }}
        alt="print"
        title="print"
      />
    </div>
    ),
  },
   {
    value: "sewing",
    label: (
      <div className="h-[100%]  content-center">
      <img
        src={`${process.env.PUBLIC_URL}/assets/sewing.png`||''}
        style={{ height: "90%",width: "90%", margin: "auto" }}
        alt="sewing"
        title="sewing"
      />
    </div>
    ),
  },
   {
    value: "inWork",
    label: (
      <div className="h-[100%]  content-center">
      <img
        src={`${process.env.PUBLIC_URL}/assets/inWork.png`||''}
        style={{ height: "90%",width: "90%", margin: "auto" }}
        alt="inWork"
        title="inWork"
      />
    </div>
    ),
  },
   {
    value: "studio",
    label: (
      <div className="h-[100%]  content-center">
      <img
        src={`${process.env.PUBLIC_URL}/assets/studio.png`||''}
        style={{ height: "90%",width: "90%", margin: "auto" }}
        alt="studio"
        title="studio"
      />
    </div>
    ),
  },
]
export const studioOptions = [
  { value: "", label: "" },
  {
    value: "inProgress",
    label: (
     
        <img
          src={`${process.env.PUBLIC_URL}/assets/inProgress.png`}
          style={{ height: "35px" }}
          alt="inProgress"
        />
      
    ),
  },
  {
    value: "client",
    label: (
      
        <img
          src={`${process.env.PUBLIC_URL}/assets/client.png`}
          style={{ height: "35px" }}
          alt="client"
        />
      
    ),
  },
  {
    value: "pancel",
    label: (
      <div style={{ display: "flex", alignItems: "center" }}>
        <img
          src={`${process.env.PUBLIC_URL}/assets/pancel.png`}
          style={{ height: "35px" }}
          alt="pancel"
        />
      </div>
    ),
  },
  {
    value: "wtf",
    label: (
      <div style={{ display: "flex", alignItems: "center" }}>
        <img
          src={`${process.env.PUBLIC_URL}/assets/wtf.png`}
          style={{ height: "35px" }}
          alt="client"
        />
      </div>
    ),
  },
  {
    value: "notFile",
    label: (
      <div style={{ display: "flex", alignItems: "center" }}>
        <img
          src={`${process.env.PUBLIC_URL}/assets/notFile.png`}
          style={{ height: "35px" }}
          alt="notFile"
        />
      </div>
    ),
  },
];

export const customStyles = {
  control: (provided) => ({
    ...provided,
    // minHeight: "50px",
    height: "90%",
    width: "90%",
    border: 'none',
    boxShadow: 'none',
    cursor: 'pointer',
    backgroundColor: "transparent",
  }),
  valueContainer: (provided) => ({
    ...provided,
    height: "60px",
    padding: "0 6px",
   
    
  }),
  input: (provided) => ({
    ...provided,
    margin: "0",
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    display: "none",
  }),
  indicatorSeparator: (provided) => ({
    ...provided,
    display: "none",
  }),
  singleValue: (provided) => ({
    ...provided,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }),
  menu: (provided) => ({
    ...provided,
    position: 'absolute',
    zIndex: 9999,
    maxHeight: "300px", // Ограничение высоты списка
    overflowY: "hidden", // Вертикальный скролл при необходимости
    overflowX: "hidden", // Отключение горизонтального скролла
    width: "70px", // Установка ширины для соответствия control
  }),
  menuList: (provided) => ({
    ...provided,
    padding: 0,
    maxHeight: '200px',
  }),
};
export const customStyles1 = {
  // control: (provided) => ({
  //   ...provided,
  //   minHeight: '50px',
  //   height: '50px',
  //   border: 'none',
  //   boxShadow: 'none',
  //   cursor: 'pointer',
  //   backgroundColor: 'transparent',
  // }),
  // menu: (provided) => ({
  //   ...provided,
  //   position: 'absolute',
  //   zIndex: 9999,
  //   backgroundColor: 'white',
  //   border: '1px solid #dbdbdb',
  //   borderRadius: '5px',
  //   boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
  // }),
  // menuList: (provided) => ({
  //   ...provided,
  //   padding: 0,
  //   maxHeight: '200px',
  // }),
  option: (provided, state) => ({
    ...provided,
    padding: '8px',
    backgroundColor: state.isSelected ? '#f0f0f0' : 'white',
    color: '#333',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#f5f5f5',
    },
  }),
  // singleValue: (provided) => ({
  //   ...provided,
  //   display: 'flex',
  //   alignItems: 'center',
  //   justifyContent: 'center',
  // }),
  // valueContainer: (provided) => ({
  //   ...provided,
  //   height: '50px',
  //   padding: '0 6px',
  //   display: 'flex',
  //   alignItems: 'center',
  // }),
  indicatorsContainer: (provided) => ({
    ...provided,
    height: '50px',
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    padding: '0 8px',
  }),
  indicatorSeparator: () => ({
    display: 'none',
  }),
};